module.exports = __webpack_public_path__ + "static/media/logo.68b41da4.svg";